/**
 *
 * @param fieldConfig {FormFieldConfig}
 * @param form {FormConfig}
 * @param context
 * @param entitiesList {EntitiesList}
 */
import DateFilterSpec from "@/server/com/silkplm/engine/forms/schema/definition/filters/DateFilterSpec";

/**
 *
 * @param fieldConfig {DateFormFieldConfig}
 * @param form
 * @param context
 * @param entitiesList
 * @param filterSpec
 * @return {DateFilterSpec}
 */
export async function dateFilter(fieldConfig, form, context, entitiesList, filterSpec) {

    let filterVal = await DialogManager.date("Select Date Range", filterSpec);
    if(filterVal === null){
        return null;
    }
    let startDate = filterVal["startDate"];
    let endDate = filterVal["endDate"];

    let spec = new DateFilterSpec();
    spec.startDateExpectedValue = startDate;
    spec.endDateExpectedValue = endDate;

    return spec;
}